const moduleList = [
	'.et_overlay',
	'.et_pb_button',
	'.et_pb_custom_button_icon',
	'.et_pb_more_button',
	'.et_pb_extra_overlay',
	'.et-pb-icon',
	'.et_pb_shop',
	'.et_pb_dmb_breadcrumbs li[data-icon]',
	'.et_pb_dmb_breadcrumbs a[data-icon]',
	'.dwd-slider-fullscreen button.slick-arrow',
	'.single_add_to_cart_button',
	'.dsm_icon_list_icon',
	'.dnxt-blurb-icon > span',
];

const targetClasses = moduleList.join();

const initLoad = () => {
	setTimeout(() => {
		processIconsDFA();
	}, 100);
};

/**
 * Parse icon data and display icons on the front end.
 *
 * @since    1.4.0
 */
function processIconsDFA() {
	let module;
	let targetElement;
	let iconData;
	const iconModules = $(targetClasses);

	// Loop through modules and work with icon data.
	for (let i = 0; i < iconModules.length; i++) {
		module = iconModules[i];
		targetElement = $(module);

		// If the module isn't found, skip this iteration.
		if (targetElement.length) {
			// If the module has a 'data-icon' attribute set, we'll use it.
			if (targetElement.data('icon') !== undefined) {
				iconData = targetElement.attr('data-icon');
				iconData = iconData.split('~|');

				if (iconData.length >= 2) {
					targetElement.attr('data-icon', iconData[0]);
				}
				// Otherwise the icon information is in the html.
			} else {
				iconData = targetElement.html();
				iconData = iconData.split('~|');

				if (iconData.length >= 2) {
					targetElement.html(iconData[0]);
				}
			}

			targetElement.attr('data-family', iconData[2]);
			targetElement.removeClass('divi_font_awesome_icon divi_font_awesome_icon--elegant-themes divi_font_awesome_icon--font-awesome divi_font_awesome_icon--undefined');
			targetElement.addClass(`divi_font_awesome_icon divi_font_awesome_icon--${iconData[2]}`);

			if (targetElement.is('[data-family]')) {
				const thisFAM = targetElement.attr('data-family');
				if (!targetElement.hasClass(`divi_font_awesome_icon--${thisFAM}`)) {
					targetElement.addClass(`divi_font_awesome_icon--${thisFAM}`);
				}
			}
		}
	}
}

export default initLoad;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/fontawesome.js